module.exports = __webpack_public_path__ + "img/auth.977558ea.jpg";